export default "__VITE_ASSET__1d2cd6d7__"